import axios from 'axios';
import { APP_ENDPOINT } from 'src/config/env.config';

export const checkResumeContent = async (resumeUrl: string, userId: string) => {
	let data = { resumeUrl, userId };
	let config = {
		method: 'post',
		url: `${APP_ENDPOINT}/api/check-resume`,
		headers: {
			'Content-Type': 'text/plain',
		},
		data: data,
	};
	try {
		const response = await axios.request(config);
		return response.data;
	} catch (err: any) {
		return { success: false };
	}
};

export const getFileNameFromeResumeLink = (link: string) => {
	let fileName = 'Resume Link';
	if (link) {
		fileName = link.substring(link.lastIndexOf('/') + 1);
	}
	return fileName;
};
